import React from "react";
import { Table } from "reactstrap";
import Api from "services/api";
import { formatServerDateTime } from "helpers/formatServerDateTime";
import ApiLogDetailModal from "components/common/ApiLogDetailModal";

const STATUS_STYLES = {
  pending: { background: "#ffb82a33", color: "#7a4f01" },
  retrying: { background: "#fd7e1433", color: "#c05600" },
  sent: { background: "#1c7c3633", color: "#1c7c36" },
  failed: { background: "#e33a3133", color: "#b51a12" },
  superseded: { background: "#80808033", color: "#555" },
  skipped: { background: "#80808033", color: "#555" },
};

/** KCDC outbound event logs for one appointment (admin View Appointment page). */
const ApiLogsTable = ({ appointmentId }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [detailLogId, setDetailLogId] = React.useState(null);

  React.useEffect(() => {
    if (!appointmentId) return;
    let active = true;
    setRows([]); // clear when navigating between appointments
    setLoading(true);
    Api.fetchApiLogs(1, { appointment_id: String(appointmentId), pageLength: 50, page: 1 })
      .then((res) => {
        if (!active) return;
        if (res?.status >= 200 && res?.status < 300) {
          setRows(res?.data?.data?.data || []);
        }
      })
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [appointmentId]);

  return (
    <div className="card_table p-4">
      <h2 className="main_heading2 mb-3">API Logs</h2>
      <div className="table_responsive">
        <Table>
          <thead className="text-primary">
            <tr>
              <th>Event Type</th>
              <th>Status</th>
              <th>Response</th>
              <th>Created At</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ textAlign: "center" }}>Loading…</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: "center" }}>No API events for this job yet</td></tr>
            ) : rows.map((log) => (
              <tr key={log.id}>
                <td style={{ whiteSpace: "nowrap" }}>{log.event_type}</td>
                <td>
                  <span style={{
                    display: "inline-block", padding: "1px 10px", fontSize: 12, fontWeight: 600,
                    borderRadius: 10, textTransform: "capitalize",
                    ...(STATUS_STYLES[log.status] || STATUS_STYLES.superseded),
                  }}>
                    {log.status}
                  </span>
                </td>
                <td>{log.response_code ?? "-"}</td>
                <td style={{ whiteSpace: "nowrap" }}>{formatServerDateTime(log.created_at)}</td>
                <td>
                  <span
                    className="link_preview"
                    style={{ cursor: "pointer" }}
                    onClick={() => setDetailLogId(log.id)}
                  >
                    View
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <ApiLogDetailModal
        logId={detailLogId}
        isOpen={detailLogId !== null}
        toggle={() => setDetailLogId(null)}
      />
    </div>
  );
};

export default ApiLogsTable;
